import ObjectFit from './_object-fit'

const $ = jQuery

export default function News () {
  const NEWS_WRAPPERS = document.querySelectorAll('.mtt-news')
  if (NEWS_WRAPPERS.length > 0) {
    for (let i = 0; i < NEWS_WRAPPERS.length; i++) {
      const newsFilter = new NewsFilter(NEWS_WRAPPERS[i])
      newsFilter.init()
    }
  }
}

class NewsFilter {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.POST_TARGET = this.WRAPPER.querySelector('.mtt-news__wrap')
    this.PAGINATION_TARGET = this.WRAPPER.querySelector('.mtt-news__pagination')
    this.LOADER = this.WRAPPER.querySelector('.mtt-news__loader')
    this.url = this.WRAPPER.getAttribute('data-main-url')
    this.id = this.WRAPPER.getAttribute('id')
    this.data = {
      action: 'filter_news',
      url: this.url,
      pagenumber: this.WRAPPER.querySelector(`#${this.id} .mtt-pagination__toggle--active`).getAttribute('data-page')
    }
  }

  init () {
    const that = this
    $(document).on('click', `#${this.id} .mtt-pagination__toggle`, function (e) {
      e.preventDefault()
      that.data.pagenumber = this.getAttribute('data-page')
      that.getPosts()
    })
  }

  showLoader () {
    this.LOADER && this.LOADER.classList.add('show')
  }

  hideLoader () {
    this.LOADER && this.LOADER.classList.remove('show')
  }

  setUrl () {
    let parametersString = ''
    const parameters = []

    // add pagenumber
    if ('pagenumber' in this.data && parseInt(this.data.pagenumber) > 1) {
      parameters.push(`pagenumber=${this.data.pagenumber}`)
    }

    if (parameters.length > 0) {
      for (let i = 0; i < parameters.length; i++) {
        parametersString += i === 0 ? '?' : '&'
        parametersString += parameters[i]
      }
    } else {
      parametersString = this.url
    }

    window.history.pushState('news', '', parametersString)
  }

  scrollTop () {
    const that = this
    $('html, body').animate({
      scrollTop: $(`#${this.id}`).offset().top - that.getOffset()
    }, 700)
  }

  getOffset () {
    let offset = 0
    const HEADER = document.getElementById('main_header')
    offset += HEADER ? HEADER.getBoundingClientRect().height : 0
    const ADMIN_BAR = document.getElementById('wpadminbar')
    offset += ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0
    return offset
  }

  runBeforeAjax () {
    this.showLoader()
  }

  runAfterAjax () {
    ObjectFit()
    this.setUrl()
    this.scrollTop()
    this.hideLoader()
  }

  getPosts () {
    this.runBeforeAjax()
    $.post(main_theme_objects.ajax_url, this.data,
      (response) => {
        if (response !== 0) {
          if (this.POST_TARGET) this.POST_TARGET.innerHTML = response.markup
          if (this.PAGINATION_TARGET) this.PAGINATION_TARGET.innerHTML = response.pagination
          this.runAfterAjax()
        }
      }
    )
  }
}
